import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'treatment-rule-list',
  methods: {
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goTreatmentLeaveList: function () {
      this.$router.push({ path: '/treatment_leave_list' })
    },
    goTreatmentSalaryList: function () {
      this.$router.push({ path: '/treatment_salary_list' })
    },
    goTreatmentDetail: function (pass) {
      this.$router.push({ path: '/treatment_detail/' + pass })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/treatment-rule-list.js